export default __webpack_public_path__ + "static/media/hihat.ce8024f6.mp3";